export default __webpack_public_path__ + "static/media/rowers5.c43d7c1d.jpg";